
import React from 'react';
import { MainLayout } from '@/components/layout/MainLayout';
import { CustomerMetaInsights } from '@/components/dashboard/CustomerMetaInsights';
import { useAuth } from '@/contexts/AuthContext';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  
  return (
    <MainLayout>
      <div className="container mx-auto py-8">
        <h1 className="text-3xl font-bold mb-6">Dashboard</h1>
        
        {/* Meta Insights for customer */}
        <div className="mb-10">
          <CustomerMetaInsights />
        </div>
        
        {/* Additional dashboard components could go here */}
      </div>
    </MainLayout>
  );
};

export default Dashboard;
